import { render, staticRenderFns } from "./CoColorPicker.vue?vue&type=template&id=ec95f9a0&scoped=true&"
import script from "./CoColorPicker.vue?vue&type=script&lang=ts&"
export * from "./CoColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./CoColorPicker.vue?vue&type=style&index=0&id=ec95f9a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec95f9a0",
  null
  
)

export default component.exports